// Bloom post-processing — the "dreamy glow bleed". Bright pixels (lanterns,
// campfires, torch flames, fireflies) bleed soft halos. Strength is driven by
// the night factor so it ONLY appears after dark; by day the render loop skips
// the composer entirely (preserving the transparent canvas + CSS sky), so this
// has zero effect in daytime / when night mode is off.

import * as THREE from 'three'
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js'
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js'
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js'
import { OutputPass } from 'three/examples/jsm/postprocessing/OutputPass.js'

const BLOOM_RADIUS = 0.4
const BLOOM_THRESHOLD = 0.92 // only the brightest cores bloom (lantern/flame centers)

function canvasSize(canvas) {
  const p = canvas.parentElement
  if (p) return { w: p.clientWidth, h: p.clientHeight }
  return { w: window.innerWidth, h: window.innerHeight }
}

export function createPostFX({ renderer, scene, camera, canvas }) {
  const { w, h } = canvasSize(canvas)
  const composer = new EffectComposer(renderer)
  composer.addPass(new RenderPass(scene, camera))
  const bloom = new UnrealBloomPass(new THREE.Vector2(w, h), 0, BLOOM_RADIUS, BLOOM_THRESHOLD)
  composer.addPass(bloom)
  composer.addPass(new OutputPass())

  const resize = () => {
    const s = canvasSize(canvas)
    if (s.w && s.h) composer.setSize(s.w, s.h)
  }
  window.addEventListener('resize', resize)
  if (typeof ResizeObserver !== 'undefined') {
    new ResizeObserver(resize).observe(canvas.parentElement ?? canvas)
  }

  return {
    setStrength(s) { bloom.strength = s },
    render() { composer.render() },
  }
}
